<div class="container-integration-merge">
      
  <app-state [state]="state">
    <ng-container *ngIf="!state.loading && !state.error">
      <ng-container *ngIf="linkedAccounts.length > 0; else templateNoLinkedAccounts;">
        <div class="card">
          <div class="content">
            <app-header [title]="'Manage your integrations'" [description]="'Manage or monitor an external integration connected to Frankli. Each integration type (HRIS, Ticketing, CRM) supports a single active connection. Please allow up to one hour for data to fully sync with Frankli.'"></app-header>

            <ng-container *ngFor="let linkedAccount of linkedAccounts">
              <div class="card">
                <div class="content">
                  <div class="area-integration-details">
                    <img [src]="linkedAccount.integration.square_image" />
                    <div class="area-integration-details-description">
                      <h4 class="standard-heading">
                        <span>{{ linkedAccount.integration.name }}</span>
                        <span class="m-right-10"></span>
                        <ng-container *ngFor="let category of linkedAccount.integration.categories">
                          <app-pill [minWidth]="0">{{ category }}</app-pill>
                        </ng-container>
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>            

            <!-- <div>
              <span>Last sync finished at:</span>
              <span class="m-right-5"></span>
              <span>{{accountToken.updatedTimestamp ? (accountToken.updatedTimestamp | date: 'MMM dd yyyy, h:mma') : 'Never'}}</span>
            </div> -->

            <hr class="row"/>

            <div class="text-center">
              <app-button (onClick)="openMergeLink()" [type]="eButtonType.GREEN_INVERTED">
                <span translate>Manage integrations</span>
              </app-button>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="content">
            <app-header [title]="'Provisioned users'" [description]="'These are the users added to Frankli through an external integration. Any sync issues will also be displayed here.'"></app-header>
  
            <ng-container *ngIf="provisionedUsers.master.length > 0; else templateNoProvisionedUsers;">
              <div class="provisioned-users-list">
                <ng-container *ngFor="let provisionedUser of provisionedUsers.page; index as index;">
                  <div class="provisioned-user-item">
                    <div class="card no-margin">
                      <div class="content">
                        <div>
                          <ng-container *ngIf="provisionedUser.user">
                            <div class="owner-img">
                              <app-profile-photo [src]="provisionedUser.user.imageUrl" [firstName]="provisionedUser.user.firstName" [lastName]="provisionedUser.user.lastName"></app-profile-photo>
                            </div>
                            <span class="m-right-15"></span>
                            <span class="d-inline-block">
                              <strong>{{provisionedUser.user.firstName}} {{provisionedUser.user.lastName}}</strong>
                              <div>
                                <span>{{provisionedUser.user.position ? provisionedUser.user.position.name : 'Role pending'}}</span>
                                <span>&nbsp;in&nbsp;</span>
                                <span>{{provisionedUser.user.organisationalUnit ? provisionedUser.user.organisationalUnit.name : 'No department'}}</span>
                              </div>
                            </span>
                          </ng-container>
                        </div>
    
                        <ng-container *ngIf="provisionedUser.errorMessage">
                          <div class="p-top-15">
                            <div class="heading-error-message">Error message:</div>
                            <app-pill [type]="ePillType.RED" [displayFullWidth]="true">{{provisionedUser.errorMessage}}</app-pill>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                    </div>
                </ng-container>
              </div>

              <app-pagination-new-component [arrayData]="provisionedUsers.master" [arrayDisplay]="provisionedUsers.page" #pagination></app-pagination-new-component>
            </ng-container>
            <ng-template #templateNoProvisionedUsers>
              <app-empty-state [height]="'300px'" [imageSrc]="'assets/img/NoUser.svg'" [message]="'No users have been added through the integration yet. Please check back in a few hours.'"></app-empty-state>
            </ng-template>
          </div>
        </div>
      </ng-container>
      <ng-template #templateNoLinkedAccounts>
        <app-empty-state [height]="'300px'"
          [imageSrc]="'assets/img/integrations/merge.svg'"
          [message]="'You are not connected to an external integration. You must complete all steps before Merge can provision users to Frankli.'"
          [primaryButtonShown]="true" [primaryButtonText]="'Manage integrations'" (primaryButtonPressed)="openMergeLink()"
        ></app-empty-state>
      </ng-template>
    </ng-container>
  </app-state>
</div>
